// eslint-diable @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
// eslint-diable @atlaskit/design-system/no-unsafe-style-overrides
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { B300, N0, N20, N200, N40, N400, N40A, N500, N60, N800, N900, P200, P300, P50 } from '@atlaskit/theme/colors';
import { TooltipPrimitive } from '@atlaskit/tooltip';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerContentBrandWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-300, 24px)"),
  justifyContent: 'space-between'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerFooterWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: "var(--ds-space-100, 8px)",
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  padding: "var(--ds-space-150, 12px)".concat(" ", "var(--ds-space-300, 24px)"),
  borderTop: "1px solid ".concat("var(--ds-border, ".concat(N40A, ")")),
  flexWrap: 'wrap'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerFeedbackWrapper = styled.div(function (_ref) {
  var isReadingAids = _ref.isReadingAids,
    isCompact = _ref.isCompact;
  return {
    display: 'flex',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginTop: !isReadingAids ? "var(--ds-space-100, 8px)" : 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBottom: !isReadingAids ? "var(--ds-space-100, 8px)" : "var(--ds-space-050, 4px)",
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: "var(--ds-text-accent-gray, ".concat(N200, ")"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: isCompact ? "0px ".concat("var(--ds-space-300, 24px)") : 'unset',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: isReadingAids ? "var(--ds-space-250, 20px)" : undefined,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingRight: isReadingAids ? "var(--ds-space-250, 20px)" : undefined
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsEditedByFooterWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: "var(--ds-space-150, 12px)".concat(" ", "var(--ds-space-250, 20px)"),
  borderTop: "1px solid ".concat("var(--ds-border, ".concat(N40A, ")"))
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export var ReadingAidsEditedByFeedbackWrapper = styled.div({
  display: 'flex',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerReportDescriptionWrapper = styled.div({
  paddingBottom: "var(--ds-space-200, 16px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var FeedbackButtonIconWrapper = styled.span(function (_ref2) {
  var active = _ref2.active,
    isDisabled = _ref2.isDisabled;
  return {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    svg: {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      color: active ? B300 : "".concat("var(--ds-text-subtlest, ".concat(N200, ")"), " !important")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    cursor: isDisabled ? 'not-allowed' : 'default'
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var Rotate180IconWrapper = styled.span({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  svg: {
    transform: 'rotate(180deg)'
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerFooterTitle = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: "var(--ds-space-050, 4px)",
  font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text-subtlest, ".concat(N200, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
export var AIAnswerTooltipWrapper = styled(TooltipPrimitive)({
  background: "var(--ds-surface-raised, ".concat(N0, ")"),
  padding: "var(--ds-space-100, 8px)",
  borderRadius: '3px',
  border: "1px solid ".concat("var(--ds-border-information, ".concat(N40A, ")")),
  boxShadow: "0 8px 12px 0 ".concat("var(--ds-shadow-overlay, ".concat(N40, ")"), ", 0 0 1px 0 ", "var(--ds-shadow-overlay, ".concat(N60, ")"))
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerInformationIconColor = "var(--ds-text-subtlest, ".concat(N200, ")");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerInformationIconWrapper = styled.div({
  display: 'flex'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerInformationTooltipLink = styled.a({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
  color: "".concat("var(--ds-text-accent-blue, ".concat(B300, ")"), " !important")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerFooterOptionWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerFollowUpPill = styled.div({
  display: 'flex',
  padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-100, 8px)"),
  color: "var(--ds-text-subtle, ".concat(N500, ")"),
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  borderRadius: '35px',
  backgroundColor: "var(--ds-background-input, ".concat(N0, ")"),
  border: "1px solid ".concat("var(--ds-border-input, ".concat(N40, ")")),
  '&:hover': {
    cursor: 'pointer',
    backgroundColor: "var(--ds-background-input-hovered, ".concat(N20, ")"),
    border: "1px solid ".concat("var(--ds-border-input, ".concat(N40, ")"))
  },
  justifyContent: 'flex-start',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerFollowUpPillText = styled.div({
  marginLeft: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsAnswerFooterWrapper = styled.div(function (_ref3) {
  var isEdited = _ref3.isEdited;
  return {
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    flexDirection: isEdited ? 'row' : 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderTop: "1px solid ".concat("var(--ds-border, ".concat(N40A, ")")),
    width: '100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: isEdited ? "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-250, 20px)") : '0'
  };
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsWrapper = styled.div({
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-250, 20px)"),
  width: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerFooterInformationContentVary = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: "var(--ds-space-050, 4px)",
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerFooterInformationContentVaryLinkText = styled.div({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerFooterPoweredBy = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  flexWrap: 'wrap'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AIAnswerFooterPoweredByAIWrapper = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: "var(--ds-space-025, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsFooterTitle = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: "var(--ds-space-050, 4px)",
  font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text-subtle, ".concat(N400, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsFeedbackLabel = styled.div({
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-text-subtle, #44546F)",
  marginRight: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
export var ReadingAidsTooltipWrapper = styled(TooltipPrimitive)({
  background: "var(--ds-background-neutral-bold, ".concat(N800, ")"),
  padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
  borderRadius: '3px',
  color: "var(--ds-text-inverse, ".concat(N0, ")"),
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  fontWeight: "var(--ds-font-weight-regular, 400)",
  width: '213px',
  height: '48px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsInformationIconColor = "var(--ds-icon, #44546F)";

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsBannerWrapper = styled.div({
  display: 'flex',
  background: "var(--ds-background-accent-purple-subtlest, ".concat(P50, ")"),
  flexDirection: 'column',
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  padding: "var(--ds-space-100, 8px)".concat(" ", "var(--ds-space-500, 36px)")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsBannerHeader = styled.div({
  display: 'flex',
  color: "var(--ds-text-accent-purple, ".concat(P300, ")"),
  fontWeight: "var(--ds-font-weight-semibold, 600)",
  alignItems: 'center',
  marginLeft: "var(--ds-space-negative-300, -24px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsBannerIconWrapper = styled.div({
  display: 'flex',
  color: "var(--ds-icon-accent-purple, ".concat(P200, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var ReadingAidsBannerDescription = styled.div({
  display: 'inline'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export var ReadingAidsEditWrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: "var(--ds-space-100, 8px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export var ReadingAidsEditedByWrapper = styled.span({
  display: 'flex',
  background: "var(--ds-background-neutral, ".concat(N900, ")"),
  padding: "var(--ds-space-0, 0px)".concat(" ", "var(--ds-space-050, 4px)"),
  borderRadius: '24px'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
export var ReadingAidsEditHistoryWrapper = styled.div({
  display: 'flex',
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: "var(--ds-link, #0C66E4)",
  paddingLeft: "var(--ds-space-300, 28px)",
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline'
  }
});